/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(document).ready(function(){
  $(".tab_content").hide();

  if($( window ).width() > 767){
    $(".tab_content:first").show();
  }
  /* if in tab mode */
  $("ul.tabs li").click(function() {

    $(".tab_content").hide();
    var activeTab = $(this).attr("rel"); 
    $("#"+activeTab).fadeIn();		

    $("ul.tabs li").removeClass("active");
    $(this).addClass("active");

    $(".tab_drawer_heading").removeClass("d_active");
    $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  });

  /* if in drawer mode */
  $(".tab_drawer_heading").click(function() {
    //$(".tab_drawer_heading").removeClass("d_active");
    //$(this).addClass("d_active");
  });
  
  $('.tab_drawer_heading').click(function(e) {
    e.preventDefault();

    var $this = $(this);

    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.next().slideUp(350);
    } 
    else {
      $this.parent().parent().find('.tab_content').removeClass('show');
      $this.parent().parent().find('.tab_content').slideUp(350);
      //$this.next().toggleClass('show');
      //$this.next().slideToggle(350);
      $this.next().show();
    }
  });
  
  $(".accordion_btn").click(function(e) {
    e.preventDefault();

    var $this = $(this);

    if ($this.hasClass('show')) {
      $this.removeClass('show');
      $this.next().slideUp(350);
    } 
    else {
      $this.addClass('show');
      $this.next().slideDown(350);
    }
    PageInits.collection('.ProductItem__Info--inner');
  });
  
  $(".tab_lists a:not(.disabled)").click(function(e) {
    e.preventDefault();

    var $this = $(this);
    var activeTab = $(this).data("id");         
    $(".tab_lists a").removeClass('active');
    $this.addClass('active');    
    $(".tab_contents .tab_inner").fadeOut(0);
    $(".tab_contents .tab_inner[data-id^='"+activeTab+"']").fadeIn(300);

    PageInits.collection('.ProductItem__Info--inner');

  });
  
  setTimeout(function(){ $('.yotpo-pictures-gallery-title').text('Follow us @animamundiherbals'); }, 2000);

  PageInits.collection('.menu-product-details');
  PageInits.collection('.ProductItem__Info--inner');

  var slider = $('.Slideshow__Carousel').flickity();
  var slider_2 = $('.shop-kook-slider').flickity();


  $(document).on("click",".arrow-wrap button.flickity-prev-next-button-next",function() {
    slider.flickity('next', true );
  });

  $(document).on("click",".arrow-wrap button.flickity-prev-next-button-previous",function() {
    console.log("previous");
    slider.flickity('previous', true );
  });


  $(document).on("click",".btn-slide.prev-next-button-next",function() {
    console.log("previous", $(this));
    slider_2.flickity('next', true );
  });

  $(document).on("click",".btn-slide.prev-next-button-previous",function() {
    console.log("previous");
    slider_2.flickity('previous', true );
  });

  var SubscriptionWidget = document.querySelector('og-offer');
  if(SubscriptionWidget){
    var observerSubscriptionWidget = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === "attributes") {
          productPageChangePrice(SubscriptionWidget);
        }
      });
    });
    observerSubscriptionWidget.observe(SubscriptionWidget, {
      attributes: true //configure it to listen to attribute changes
    });
    
    let observerVariantChange = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if(mutation.target.classList.contains("is-selected")){
          let selectedElement = mutation.target;
          let variantTitle = selectedElement.getAttribute("data-value");
          let variantId = $(`select[name='id'] option[data-variant-title="${variantTitle}"]`).attr("data-variant-id");
          $(document).find("og-offer.og-offer").attr("product", variantId);
          productPageChangePrice(SubscriptionWidget);
        }
      });
    });
    let variantDropDown = document.querySelectorAll(".Popover__Value");
    if(variantDropDown.length){
      variantDropDown.forEach((elementInstance)=>{
        observerVariantChange.observe(elementInstance, {
          attributes : true,
        });
      });
    }

    (function(){
      productPageChangePrice(SubscriptionWidget)
    })();
  }
  function productPageChangePrice(element){
    let variantId = document.querySelector("[name='id']").value;
    let discountedPrice = document.querySelector(".variant-subscription-details").querySelector(`[data-vid='${variantId}']`).getAttribute("data-discount");
    console.log(variantId,discountedPrice )
    let price = document.querySelector(".variant-subscription-details").querySelector(`[data-vid='${variantId}']`).getAttribute("data-price");
     document.querySelector("og-price[subscription]").shadowRoot.textContent = (discountedPrice.includes(".00")) ? discountedPrice = discountedPrice.replace(".00", "") : discountedPrice ;	
    document.querySelector("og-price[regular]").shadowRoot.textContent = (price.includes(".00")) ? price = price.replace(".00", "") : price ; 
    if(element.hasAttribute("subscribed")){
      document.querySelector(".Product__Info [data-money-convertible]").innerText = (discountedPrice.includes(".00")) ? discountedPrice = discountedPrice.replace(".00", "") : discountedPrice ;
    }else{
      document.querySelector(".Product__Info [data-money-convertible]").innerText = (price.includes(".00")) ? price = price.replace(".00", "") : price ; 
    }
  
  }

});

var PageInits = {
  collection: function(a){
    var top = 0;
    var main = $(a);
    var randomClass = ( 'eH' + Math.random() ).replace('.','');
    // console.log('A random class: ' + randomClass); // ?
    main.each( function() {

      var distanceFromTop = $(this).offset().top;
      // console.log('This is ' + distanceFromTop + ' from the top.');

      if ( distanceFromTop > top ) {
        $('.' + randomClass).removeClass(randomClass);
        top = distanceFromTop;
        // console.log('"top" is ' + top + 'px away');
      }

      $(this).addClass(randomClass);

      $(this).css('height','auto');

      var newHeight = (Math.max.apply(null, $('.' + randomClass).map( function() {
        return $(this).outerHeight();
      }).get()));

      $('.' + randomClass).css('height',newHeight);

    }).removeClass(randomClass);

  }
}

$( window ).scroll(function() {
  PageInits.collection('.section-blog .ArticleItem__Content .ArticleItem__Title');
});
$(window).resize(function(){
  PageInits.collection('.menu-product-details');
  PageInits.collection('.ProductItem__Info--inner');
});